import { render } from "./MdProgressSpinner.vue?vue&type=template&id=88df5e46"
import script from "./MdProgressSpinner.vue?vue&type=script&lang=js"
export * from "./MdProgressSpinner.vue?vue&type=script&lang=js"

import "./MdProgressSpinner.vue?vue&type=style&index=0&id=88df5e46&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__